<template>
  <div id="emailOAValidationFormWrap">
    <el-card
      id="emailOAValidationForm"
      :style="{width: dialogWidth}"
      shadow="hover"
    >
      <div slot="header">
        Email Validation
      </div>

      <div
        v-loading="state === 'loading'"
        class="content"
      >
        <el-form
          v-if="formVisible"
          ref="createOAForm"
          label-width="170px"
          :model="createOAForm"
          :rules="rules"
          @submit.native.prevent="submit"
        >
          <el-form-item
            prop="email"
            label="Email"
            :error="error.email[0]"
          >
            <el-input
              v-model="createOAForm.email"
              :disabled="true"
            />
          </el-form-item>

          <el-form-item
            prop="new_password"
            label="Password"
            :error="error.new_password[0]"
          >
            <el-input
              v-model="createOAForm.new_password"
              type="password"
            />
          </el-form-item>

          <el-form-item
            prop="passwordConfirmation"
            label="Password Confirmation"
          >
            <el-input
              v-model="createOAForm.passwordConfirmation"
              type="password"
            />
          </el-form-item>

          <el-form-item
            prop="first_name"
            label="First Name"
            :error="error.first_name[0]"
          >
            <el-input v-model="createOAForm.first_name" />
          </el-form-item>

          <el-form-item
            prop="last_name"
            label="Last Name"
            :error="error.last_name[0]"
          >
            <el-input v-model="createOAForm.last_name" />
          </el-form-item>

          <el-form-item
            prop="organization_name"
            label="Organization Name"
            :error="error.organization_name[0]"
          >
            <el-input v-model="createOAForm.organization_name" />
          </el-form-item>

          <el-form-item
            prop="time_zone"
            label="Timezone"
            class="timezoneItem"
          >
            <el-select
              v-model="createOAForm.time_zone"
              filterable
              placeholder="Search timezone"
            >
              <el-option
                v-for="item in timezonesList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="submit"
            >
              Validate Account
            </el-button>
          </el-form-item>
        </el-form>

        <div
          v-if="!formVisible"
          class="validationMessage"
        >
          <i class="el-icon-success"></i><br /><br />
          <span>
            The user has been created!
          </span>
          <br />
          <span>
            You will now be redirected to your
            <router-link :to="{name: 'dashboard'}"> dashboard</router-link>.
          </span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import api from '@/api';

export default {
  props: {
    dialogWidth: {
      type: String,
      default: '50%',
    },
  },
  data() {
    return {
      timezonesList: [],
      createOAForm: {
        email: '',
        // new_password: '',
        // passwordConfirmation: '',
        // first_name: '',
        // last_name: '',
        // organization_name: '',
        // time_zone: '',
        new_password: '12345678',
        passwordConfirmation: '12345678',
        first_name: 'Benjamin',
        last_name: 'Vasseur',
        organization_name: 'Marshall Goldsmith',
        time_zone: 'Asia/Seoul',
      },

      rules: {
        email: [
          { required: true, message: 'Please input email address', trigger: 'blur' },
          { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] },
        ],
        new_password: [
          { required: true, message: 'Please input password', trigger: 'blur' },
          { min: 6, message: 'Password should be at least 6 caracters', trigger: 'blur' },
        ],
        passwordConfirmation: [
          { required: true, message: 'Please input password confirmation', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (this.createOAForm.new_password !== this.createOAForm.passwordConfirmation) {
                callback(new Error('Two inputs don\'t match!'));
              }
              callback();
            },
            trigger: 'blur',
          },
        ],
        first_name: [
          { required: true, message: 'Please input first name', trigger: 'blur' },
        ],
        last_name: [
          { required: true, message: 'Please input last name', trigger: 'blur' },
        ],
        organization_name: [
          { required: true, message: 'Please input organization name', trigger: 'blur' },
        ],
        timezone: [
          { required: true, message: 'Please input your timezone', trigger: 'blur' },
        ],
      },

      error: {
        email: [],
        new_password: [],
        first_name: [],
        last_name: [],
        organization_name: [],
      },

      state: 'creating',
    };
  },

  computed: {
    formVisible() {
      return !this.state || this.state === 'creating' || this.state === 'loading';
    },
  },

  created() {
    this.validateEmail();
    this.getTimezoneList();
  },

  methods: {
    ...mapMutations('user', [
      'loginUser',
    ]),

    async validateEmail() {
      this.state = 'loading';
      const { uid } = this.$route.params;
      const { token } = this.$route.params;
      try {
        const response = await api.emailValidation(uid, token);
        this.createOAForm.email = response.data.email;
        this.state = 'creating';
      } catch (err) {
        this.$message.error(err.response.data.Error[0]);
        this.state = 'creating';
      }
    },

    async submit() {
      this.$refs.createOAForm.validate(async (valid) => {
        if (valid) {
          this.state = 'loading';
          try {
            const data = { ...this.createOAForm };
            delete data.passwordConfirmation;
            data.organization = {
              name: data.organization_name,
            };
            delete data.organization_name;
            const response = await api.organizationSignUp(data);
            this.state = 'valid';

            await this.loginUser(response.data);

            const that = this;
            setTimeout(async () => {
              that.$router.push({ name: 'dashboard' }).catch((err) => {});
            }, 5000);
          } catch (err) {
            const { data } = err.response;
            Object.keys(data).forEach((key) => {
              if (key in this.error) {
                this.error[key] = data[key];
              }
            });
            this.state = 'creating';
          }
        }
        return false;
      });
    },

    async getTimezoneList() {
      try {
        const response = await api.getTimezoneList();
        this.timezonesList = response.data.map((el) => ({
          value: el,
          label: el.replace('_', ' '),
        }));
      } catch (err) {
        this.$message.error(err.response.data.detail);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#emailOAValidationFormWrap {
  width: 100%;

  #emailOAValidationForm {
    margin: 0 auto;

    .timezoneItem {
      text-align: left;
    }
  }
}
</style>
